nativeReverse